import config from '@/config'
import HttpClient from '@/api/http/client'
import ResponseError from '@/api/http/ResponseError'

const http = new HttpClient(config.skylerBaseUrl)

export default {
  async createSubscription(accountId, cpf, skyCode) {
    const response = await http.post('/v1/subscribe', { accountId, cpf, skyCode })

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  }
}
